import { useEffect, useState } from 'react';
import { SIGNUP_STEPS, WEIGHT_UNIT } from '../../../types/enum';
import { isNumber } from '../../../lib/validation';

const HeightWeight = ({
  height,
  setHeight,
  weight,
  setWeight,
  setCurrentStep,
  weightUnit,
  handleWeightUnit,
}) => {
  const [heightOptions, setHeightOptions] = useState([]);
  const [weightOptions, setWeightOptions] = useState([]);

  useEffect(() => {
    setHeightOptions(Array.from({ length: 150 }, (_, i) => i + 100));
    setWeightOptions(
      Array.from(
        { length: weightUnit === WEIGHT_UNIT.LB ? 380 : 200 },
        (_, i) => i + (weightUnit === WEIGHT_UNIT.LB ? 60 : 20)
      )
    );
  }, [weightUnit]);

  const handleInput = (key) => (e) => {
    const value = String(e.target.value);
    if (key === 'height') {
      setHeight(isNaN(Number(value)) ? '' : Number(value));
    }
    if (key === 'weight') {
      setWeight(isNaN(Number(value)) ? '' : Number(value));
    }
  };

  const handleNext = () => {
    try {
      isNumber(height);
      isNumber(weight);
      setCurrentStep(SIGNUP_STEPS.NATIONALITY);
    } catch (err) {
      alert(err.message);
    }
  };

  return (
    <div>
      <div className='flex justify-end mb-4'>
        <button
          className={`relative inline-flex items-center h-6 rounded-full w-11 ${
            weightUnit === WEIGHT_UNIT.KG ? 'bg-yellow-500' : 'bg-gray-200'
          }`}
          onClick={handleWeightUnit}
        >
          <span className='sr-only'>Toggle weight unit</span>
          <span
            className={`${
              weightUnit === WEIGHT_UNIT.KG ? 'translate-x-6' : 'translate-x-1'
            } inline-block w-4 h-4 transform bg-white rounded-full transition-transform duration-200 ease-in-out`}
          />
        </button>
        <span className='ml-2 text-white text-sm font-medium'>
          {weightUnit}
        </span>
      </div>
      <h1 className='font-bold mb-1 text-white text-4xl'>
        What's your height and weight?
      </h1>
      <p className='mb-3 text-xs italic text-white'>
        This information is required to accurately calculate BMI and BMR.
      </p>
      <div className='mb-5 space-y-2'>
        <div className='flex items-center gap-2'>
          <select
            className='w-full bg-white rounded-full py-3 px-4 '
            onChange={handleInput('height')}
            value={height ?? ''}
          >
            <option
              value=''
              disabled
            >
              Select Height
            </option>
            {heightOptions.map((option) => (
              <option
                key={option}
                value={option}
              >
                {option}
              </option>
            ))}
          </select>
          <div className='text-white text-sm font-bold'>cm</div>
        </div>
        <div className='flex items-center gap-2'>
          <select
            className='w-full bg-white rounded-full py-3 px-4 '
            onChange={handleInput('weight')}
            value={weight ?? ''}
          >
            <option
              value=''
              disabled
            >
              Select Weight
            </option>
            {weightOptions.map((option) => (
              <option
                key={option}
                value={option}
              >
                {option}
              </option>
            ))}
          </select>
          <div className='text-white text-sm font-bold'>
            {weightUnit === WEIGHT_UNIT.KG ? 'kg' : 'lb'}
          </div>
        </div>
      </div>
      <button
        className={`w-full bg-yellow-500 text-black font-bold rounded-full hover:bg-yellow-600 transition-colors duration-200 py-3 ${
          !height || !weight
            ? 'opacity-40'
            : 'hover:bg-yellow-600 transition-colors duration-200'
        }`}
        onClick={handleNext}
        disabled={!height || !weight}
      >
        Next
      </button>
    </div>
  );
};

export default HeightWeight;
